import { Component, OnInit, inject, input, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

import { ROUTER_UTILS } from '../../../utils/router.utils';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  imports: [HeaderComponent, FooterComponent],
})
export class LayoutComponent implements OnInit {
  private router = inject(Router);

  // Header and footer only. The projected outlet renders either way, so signing
  // in or out changes the chrome around the page without tearing the page down.
  public readonly signedIn = input(false);

  public readonly showMemu = signal(false);

  ngOnInit(): void {
    this.updateShowMenu();

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateShowMenu();
      });
  }

  private updateShowMenu(): void {
    if (
      this.router.url.startsWith(
        '/' + ROUTER_UTILS.config.reports.drivingStyle,
      ) ||
      this.router.url.startsWith(
        '/' + ROUTER_UTILS.config.reports.routeDetail,
      ) ||
      // NFC sign-in: a driver taps a tag to do one thing. Nothing else on the
      // screen should be tappable.
      this.router.url.startsWith('/' + ROUTER_UTILS.config.base.tag)
    ) {
      this.showMemu.set(false);
    } else {
      this.showMemu.set(true);
    }
  }
}
